import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateWechatState } from "../../../redux/slice/wechatSlice";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Toast } from 'antd-mobile';
import BottomNavLayout from "../../../components/BottomNavLayout";
import CountDown from "../../../components/CountDown";
import PubHeader from "../../../components/PubHeader";
import ListOrderView from "../ListOrder/ListOrderView";
import PayChannel from "./PayChannel";
import api from "../../../api";
import { isWxOrAli } from "../../../utils/env";
import "./style.less"

const PayOrder = () => {
  const wechatState = useSelector((state) => state.wechat)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [time, setTime] = useState(0)
  const [order, setOrder] = useState()
  const [payed, setPayed] = useState(false)
  const [timeover, setTimeover] = useState(false)
  const [payChannel, setPayChannel] = useState()

  const params = useParams()
  const { orderId } = params

  // 判断当前是微信 or 支付宝
  const aliOrWx = isWxOrAli();

  // 处理ios异常url
  let url = wechatState.ios ? wechatState.url : window.location.href;

  // 获取全局wx对象
  const wx = window.wx;

  // 获取订单详情
  const refreshOrderDetail = () => {
    api.userOrderDetail({ orderId }).then((res) => {
      const data = res.data
      if (!data) {
        return
      }
      if (data.code !== 0) {
        Toast.show({ content: data.message })
        return
      }

      setOrder(data.data)

      // 计算剩余时间 - iOS不支持 '2022-08-11 12:13:56' 的时间格式
      const createdDate = data.data.createdDate.replace(/-/g, '/')
      const ct = Date.parse(createdDate)
      const now = Date.now()
      const dv = ct + 60 * 2 * 1000 - now;

      if (dv <= 0) {
        setTimeover(true)
        return
      }

      // 倒计时比实际时间少3秒，避免结束后刷新订单progress==1
      setTime(Math.floor(dv / 1000) - 3)
    })
  }

  // 微信初始化配置
  // https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#4
  const wxConfig = (realAuthUrl) => {
    api.wechatJsapiSignature({ url: realAuthUrl }).then((res) => {
      let signature = res.data.data;
      signature.jsApiList = ['scanQRCode', 'chooseWXPay'];
      signature.openTagList = ['wx-open-launch-weapp'];

      wx.config(signature);

      wx.ready(function () {
        // IOS环境特殊处理
        if (wechatState.ios) {
          const newWechatState = {
            url: wechatState.url,
            ios: wechatState.ios,
            loaded: wechatState.loaded,
            iosReady: true
          }
          dispatch(updateWechatState(newWechatState))
        }
      });

      wx.error(function (res) {
        // alert("error : " + JSON.stringify(res))
      });
    });
  }

  // 处理支付按钮点击事件
  const handlePayClick = () => {
    if (!order) {
      return
    }

    if (!payChannel) {
      Toast.show({ content: '请先选择支付方式' })
      return
    }

    // 选择钱包支付
    if (payChannel.channelId === 3) {
      // 校验余额
      if (payChannel.balance < order.payFee) {
        Toast.show({ content: '余额不足，请选择其他支付方式' })
        return
      }

      // 拉起支付
      api.orderPay({ payChannel: 3, orderNo: order.orderNo }).then((resp) => {
        if (resp.data?.code === 0) {
          // 跳转到支付结果页
          navigate('/order/pay/result/payed')
        } else {
          Toast.show({ content: '支付失败，请稍后重试' })
          return
        }
      })
    }

    // 选择微信支付
    else if (payChannel.channelId === 1) {
      // 获取支付参数
      api.orderPay({ payChannel: 1, orderNo: order.orderNo }).then((res) => {
        const data = res.data;
        if (!data) {
          Toast.show({ content: '支付失败，请稍后重试' })
          return
        }
        if (data.code !== 0) {
          Toast.show({ content: data.message })
          return
        }

        const payParams = data.data;

        // https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#58
        wx.chooseWXPay({
          appId: payParams.appId,
          timestamp: payParams.timeStamp,
          nonceStr: payParams.nonceStr,
          package: payParams.package,
          signType: payParams.signType,
          paySign: payParams.paySign,
          success: function (res) {
            setPayed(true)

            // 跳转到支付结果页
            navigate('/order/pay/result/payed')
          }
        })
      })
    } else if (payChannel.channelId === 2) {
      api.orderPay({ payChannel: 2, orderNo: order.orderNo }).then((res) => {
        const data = res.data;
        document.getElementById("alipay-form").innerHTML = data.data;
        document.forms[0].submit();
      })
    }
  }

  // 处理取消按钮点击事件
  const handleCancelClick = () => {
    if (!order) {
      return
    }

    api.orderCancel({ orderId: order.id }).then((res) => {
      if (res?.data?.code === 0) {
        // 跳转到支付结果页
        navigate('/order/pay/result/cancelled')
      } else {
        Toast.show({ content: '订单取消失败，请稍后重试' })
      }
    })
  }

  // 处理倒计时结束事件
  const handleCountDownOver = () => {
    // refreshOrderDetail()
    setTimeover(true)
    // 跳转到支付结果页
    navigate('/order/pay/result/autocancelled')
  }

  // 触发刷新页面
  useEffect(() => {
    if (aliOrWx === 'wechat') {
      // 非ios平台每次都需要config
      if (!wechatState.ios || !wechatState.iosReady) {
        wxConfig(url)
      }
    }

    if (orderId) {
      refreshOrderDetail()
    }
  }, [orderId, payed])


  // 未查询到订单信息
  if (!order) {
    return (
      <BottomNavLayout>
        <PubHeader title="支付" />
        <div className="order-hint-wrapper">
          无效订单信息。
        </div>
      </BottomNavLayout>
    )
  }

  // 倒计时未结束 并且 progress==待支付
  if (!timeover && order.progress === 1) {
    return (
      <BottomNavLayout>
        <PubHeader title="支付" />
        <ListOrderView order={order} canClick={false} />
        <CountDown time={time} onTimeOver={handleCountDownOver} />
        <PayChannel setPayChannel={setPayChannel} />
        <div className="pay-button-wrapper">
          <div className="pay-button">
            <Button block color='success' size='large' onClick={handlePayClick}>
              支 付
            </Button>
            <br />
            <Button block color='warning' size='large' onClick={handleCancelClick}>
              取 消
            </Button>
          </div>
        </div>
        <div id="alipay-form"></div>
      </BottomNavLayout>
    )
  }

  // 支付超时 & 状态未取消
  if (timeover && order.progress === 1) {
    return (
      <BottomNavLayout>
        <PubHeader title="支付" />
        <ListOrderView order={order} canClick={false} />
        <div className="order-hint-wrapper">
          <p>订单已超时，请取消订单。</p>
        </div>
        <div className="pay-button-wrapper">
          <div className="pay-button">
            <Button block color='warning' size='large' onClick={handleCancelClick}>
              取 消
            </Button>
          </div>
        </div>
      </BottomNavLayout>
    )
  }

  // 订单已取消
  if ((!payed && timeover) || order.progress === 6) {
    return (
      <BottomNavLayout>
        <PubHeader title="支付" />
        <ListOrderView order={order} canClick={false} />
        <div className="order-hint-wrapper">
          <p>订单已取消，如有需要请重新下单。</p>
        </div>
      </BottomNavLayout>
    )
  }

  // 已支付或者订单状态
  if (payed || order.progress === 2) {
    return (
      <BottomNavLayout>
        <PubHeader title="支付" />
        <ListOrderView order={order} canClick={false} />
        <div className="order-hint-wrapper">
          <p>订单已支付，请勿重复支付。</p>
        </div>
      </BottomNavLayout>
    )
  }
}

export default PayOrder;